export const blockIconsActionDescription = (
	<span className='material-symbols-outlined'>description</span>
);
